import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97057d30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "links" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "a" }



    interface IProps {
        links: Array<any>
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'NavLinks',
  props: {
    links: {}
  },
  setup(__props: any) {

const props = __props;

    
    


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.links, (l) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-link",
          key: l.name
        }, [
          _createElementVNode("a", {
            href: l.routerPath,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(l.name.toUpperCase()), 1)
          ], 8, _hoisted_2)
        ]))
      }), 128))
    ])
  ]))
}
}

})